'use client'

import React, { createContext, useEffect, useState } from "react"

import { Locale } from "@/i18n/i18n-config"
import { pushEventToDataLayer } from "@/stories/utilities/helpers/helpers"

const LocaleContext = createContext<Locale | null>(null)

export default function LocaleProvider({
    locale: currentLocale,
    children,
}: {
    locale: Locale
    children: React.ReactNode
}) {
    const [locale, setLocale] = useState<string | null>(localStorage.getItem('locale'))

    useEffect(() => {
        if (!locale || locale !== currentLocale) {
            pushEventToDataLayer('localeSet', { locale: currentLocale });
    
            localStorage.setItem('locale', currentLocale);
    
            setLocale(currentLocale);
        }
    }, [locale, currentLocale]);
    
    return (
        <LocaleContext.Provider value={currentLocale}>
            {children}
        </LocaleContext.Provider>
    )
}

export function useLocale() {
    const locale = React.useContext(LocaleContext)

    if (!locale) {
        throw new Error('useLocale hook must be used within LocaleProvider')
    }

    return locale
}